import CircleView from "./circleview";
import DragDropHandler from "./dragdrop";
import CircleItem from "./circleitem";
import EarringsView from "./earringsview";
import EaringItem from "./earingitem";

var EARING_TYPE = 7; // Khuyên tai
var categoryType;

let DesignTool = {
  container: {
    target: document.body,
    size: {
      width: 0,
      height: 0
    }
  },

  _callbacks: {},

  initialize(type, target, perimeter) {
    categoryType = type;

    if (!(target instanceof HTMLElement)) {
      throw new Error(JSON.stringify({ error: "errors.HTMLElementUndefined" }));
      return false;
    }

    let _target =
      window.hasOwnProperty("jQuery") && target instanceof jQuery
        ? target[0]
        : target;

    let _size = {};

    this.container = {
      target: _target,
      size: _size
    };

    this.container.target.textContent = "";
    if (categoryType === EARING_TYPE) {
      this.earringsView = new EarringsView(this.container, perimeter);

      // register drag & drop events
      this.handler = new DragDropHandler(this.earringsView, null, categoryType);
      if (this.pendingItems && this.pendingItems.length > 0) {
        [].forEach.call(
          this.pendingItems,
          function(o) {
            this.handler.registerDrag(o);
          },
          this
        );
      }
      Object.keys(this._callbacks).forEach(function(event) {
        if (typeof this._callbacks[event] !== "undefined") {
          this._callbacks[event].forEach(cb => this.earringsView.on(event, cb));
        }
      }, this);
    } else {
      // this.container.target.style.position = 'relative';
      this.circleView = new CircleView(this.container, perimeter);
      // register drag & drop events
      this.handler = new DragDropHandler(this.circleView, null, categoryType);
      if (this.pendingItems && this.pendingItems.length > 0) {
        [].forEach.call(
          this.pendingItems,
          function(o) {
            this.handler.registerDrag(o);
          },
          this
        );
      }
      Object.keys(this._callbacks).forEach(function(event) {
        if (typeof this._callbacks[event] !== "undefined") {
          this._callbacks[event].forEach(cb => this.circleView.on(event, cb));
        }
      }, this);
    }
  },

  updateSizeRing() {
    this.circleView.FabricCanvas.setHeight(168);
    this.circleView.FabricCanvas.renderAll();
  },

  changeView(type, perimeter) {
    var myNode = this.container.target;
    var curentView = null;

    while (myNode.firstChild) {
      myNode.removeChild(myNode.firstChild);
    }

    if (type === EARING_TYPE) {
      this.earringsView = new EarringsView(this.container, perimeter);
      this.handler.registerListeners(this.earringsView);
      curentView = this.earringsView;
    } else {
      this.circleView = new CircleView(this.container, perimeter);
      this.handler.registerListeners(this.circleView);
      curentView = this.circleView;
    }
    Object.keys(this._callbacks).forEach(function(event) {
      if (typeof this._callbacks[event] !== "undefined") {
        this._callbacks[event].forEach(cb => curentView.on(event, cb));
      }
    }, this);
  },

  addItem(
    sizeID,
    imageDesign,
    imageSize,
    size,
    productID,
    productType,
    hookPos
  ) {
    if (this.circleView.animating) {
      return false;
    }
    this.circleView.addItem(
      new CircleItem(
        sizeID,
        imageDesign,
        imageSize,
        size,
        productID,
        productType,
        -1,
        this.circleView.r,
        hookPos
      )
    );
    return true;
  },

  addItem(
    type,
    angle,
    sizeID,
    imageDesign,
    imageSize,
    size,
    productID,
    productType,
    hookPos
  ) {
    if (type === EARING_TYPE) {
      this.earringsView.addItem(
        new EaringItem(
          sizeID,
          imageDesign,
          imageSize,
          size,
          productID,
          productType,
          angle
        )
      );
    } else {
      if (this.circleView.animating) {
        return false;
      }
      this.circleView.addItem(
        new CircleItem(
          sizeID,
          imageDesign,
          imageSize,
          size,
          productID,
          productType,
          angle,
          this.circleView.r,
          hookPos
        )
      );
    }
    return true;
  },

  addItemChangeSize(
    type,
    angle,
    sizeID,
    imageDesign,
    imageSize,
    size,
    productID,
    productType,
    hookPos,
    oldItems
  ) {
    if (type === EARING_TYPE) {
      this.earringsView.addItem(
        new EaringItem(
          sizeID,
          imageDesign,
          imageSize,
          size,
          productID,
          productType,
          angle
        )
      );
    } else {
      if (this.circleView.animating) {
        return false;
      }
      this.circleView.addItemChangeSize(
        new CircleItem(
          sizeID,
          imageDesign,
          imageSize,
          size,
          productID,
          productType,
          angle,
          this.circleView.r,
          hookPos
        ),
        oldItems
      );
    }
    return true;
  },

  insertItem(
    angle,
    sizeID,
    imageDesign,
    imageSize,
    size,
    productID,
    productType,
    hookPos
  ) {
    if (this.circleView.animating) {
      return false;
    }
    let item = new CircleItem(
      sizeID,
      imageDesign,
      imageSize,
      size,
      productID,
      productType,
      angle,
      this.circleView.r,
      hookPos
    );
    this.circleView.insertItem(angle, item);
    return true;
  },

  addItems(items) {
    if (this.circleView.animating) {
      return false;
    }
    for (var i = 0; i < items.length; i++) {
      let item = items[i];
      let tmp = new CircleItem(
        item.sizeID,
        item.imageDesign,
        item.imageSize,
        item.size,
        item.productID,
        item.productType,
        item.angle,
        this.circleView.r,
        item.hookPos
      );
      this.circleView.insertItem(item.angle, tmp);
    }
    return true;
  },

  createItem(
    sizeID,
    imageDesign,
    imageSize,
    size,
    productID,
    productType,
    hookPos
  ) {
    return new CircleItem(
      sizeID,
      imageDesign,
      imageSize,
      size,
      productID,
      productType,
      -1,
      0,
      hookPos
    );
  },

  clearItems() {
    if (categoryType === EARING_TYPE) {
      this.earringsView.clearItems();
    } else {
      this.circleView.clearItems();
    }
  },

  getItems() {
    if (categoryType === EARING_TYPE) {
      return this.earringsView.items;
    } else {
      return this.circleView.items;
    }
  },

  registerDrag(e) {
    if (this.handler) {
      if((e.productType == 6 && e.hookPos != null) || e.productType != 6) {
        this.handler.registerDrag(e);
      }
    } else {
      if (!this.pendingItems) {
        this.pendingItems = [];
      }
      this.pendingItems.push(e);
    }
  },

  unregisterDrag(e) {
    if (this.handler) {
      this.handler.unregisterDrag(e);
    }
  },

  getPNGBase64(showNumber = false) {
    if (categoryType === EARING_TYPE) {
      return this.earringsView.toPNGBase64(showNumber);
    } else {
      return this.circleView.toPNGBase64(showNumber);
    }
  },

  drawNumber() {
    this.circleView.drawNumber();
  },

  on(event, callback) {
    if (typeof callback === "function") {
      if (typeof this._callbacks[event] === "undefined") {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(callback);
      if (this.circleView) {
        this.circleView.on(event, callback);
      }
    }
  },

  off(event, callback) {
    if (typeof callback === "function") {
      if (typeof this._callbacks[event] === "undefined") {
        this._callbacks[event] = [];
      }
      let idx = this._callbacks[event].indexOf(callback);
      if (idx >= 0) {
        this._callbacks[event].splice(idx, 0);
        if (this.circleView) {
          this.circleView.off(event, callback);
        }
      }
    }
  },

  touchZoom(beforeW, afterW, type) {
    if (type === EARING_TYPE) {
      this.earringsView.zoomEarring(beforeW, afterW);
    } else {
      this.circleView.zoomCircle(beforeW, afterW);
    }
  },

  initializeDesign(type, target, perimeter,design) {
    var itemRingSizeMin = design.ringSize;
    var itemRingSizeMax = design.ringSize;
    if(design.ringTypeId!=EARING_TYPE){
        if(design.ringSizeMin) itemRingSizeMin=design.ringSizeMin;
        if(design.ringSizeMax) itemRingSizeMax=design.ringSizeMax;
    }
    this.initialize(type,target,perimeter);
    if(this.circleView) {
      this.circleView.ringSizeMin=itemRingSizeMin;
      this.circleView.ringSizeMax=itemRingSizeMax;
    }
  },
  getSizeDesignMin(design) {
    var itemRingSizeMin = design.ringSize;
    if(design.ringTypeId!=EARING_TYPE){
        if(design.ringSizeMin) itemRingSizeMin=design.ringSizeMin;
    }
    return itemRingSizeMin;
  },
  getSizeDesignMax(design) {
    var itemRingSizeMax = design.ringSize;
    if(design.ringTypeId!=EARING_TYPE){
        if(design.ringSizeMax) itemRingSizeMax=design.ringSizeMax;
    }
    return itemRingSizeMax;
  },
  getMinMaxSizeFromListItem(ringsData,ringTypeId){
    var itemRingSizeMin=ringsData.rings[0].sizes[0].size;
    var itemRingSizeMax=ringsData.rings[0].sizes[0].size;
    if(ringTypeId!=EARING_TYPE){
        ringsData.rings[0].sizes.forEach(item => {
          if(item.max_size>itemRingSizeMax) itemRingSizeMax=item.max_size;
          if(item.size<itemRingSizeMin) itemRingSizeMin=item.size;
        });
        if(itemRingSizeMin>itemRingSizeMax) itemRingSizeMin =itemRingSizeMax;
    }
    return {  ringSizeMin:itemRingSizeMin,ringSizeMax:itemRingSizeMax };
  },
  initializeDesignAndDesignInfo(type, target, perimeter,itemRing,designInfo,tmpDesignInfo) {
    var itemRingSizeMin=this.circleView.ringSizeMin;
    var itemRingSizeMax=this.circleView.ringSizeMax;
    if(this.circleView) {
      itemRingSizeMin=this.circleView.ringSizeMin;
      itemRingSizeMax=this.circleView.ringSizeMax;
    }
   
    designInfo.ringId= itemRing.id,
    designInfo.ringSize= itemRing.sizes[0].size,
    designInfo.ringSizeMin= itemRingSizeMin,
    designInfo.ringSizeMax= itemRingSizeMax,
    designInfo.ringColor= itemRing.colors[0].color_name,
    designInfo.ringPrice= itemRing.price,
    designInfo.ringColorCode= itemRing.colors[0].color_code
    tmpDesignInfo.ringId= itemRing.id,
    tmpDesignInfo.ringSize= itemRing.sizes[0].size,
    tmpDesignInfo.ringSizeMin= itemRingSizeMin,
    tmpDesignInfo.ringSizeMax= itemRingSizeMax,
    tmpDesignInfo.ringColor= itemRing.colors[0].color_name,
    tmpDesignInfo.ringPrice= itemRing.price,
    tmpDesignInfo.ringColorCode= itemRing.colors[0].color_code
    this.initialize(type,target,perimeter);
    if(this.circleView) {
      this.circleView.ringSizeMin=itemRingSizeMin;
      this.circleView.ringSizeMax=itemRingSizeMax;
    }
  }


};

export default DesignTool;
